import { render, staticRenderFns } from "./Rosters.vue?vue&type=template&id=aebe3388&lang=pug&"
import script from "./Rosters.vue?vue&type=script&lang=js&"
export * from "./Rosters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports